
import { MultiPrintArbre } from '@repo/print-pdf/arbre/print';


export default function MultiPrintArbrePage() {

  return (
    <div className="w-full py-6">
      <MultiPrintArbre />
    </div>
  );
}
